import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Sidebar2Component } from './sidebar2.component';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { SidebarSubmenuItemComponent } from './sidebar-item/sidebar-submenu-item/sidebar-submenu-item.component';
import { RouterModule } from '@angular/router';
import { Sidebar2Service } from './sidebar2.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule],
  providers: [Sidebar2Service],
  declarations: [
    Sidebar2Component,
    SidebarItemComponent,
    SidebarSubmenuItemComponent,
  ],
  exports: [Sidebar2Component],
})
export class SidebarModule {}
